"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEmailDocument = exports.isEmailDocumentEmpty = exports.hasBrokenEmailPlaceholder = exports.extractEmailDocumentTokens = exports.plainTextToEmailDocument = exports.EmailDocumentSchema = exports.isSafeEmailHref = exports.EMAIL_BODY_MAX_LENGTH = exports.EMAIL_TOKEN_NODE = exports.EMAIL_HEADING_LEVELS = exports.EMAIL_TEXT_ALIGNMENTS = exports.EmailBodyFormatSchema = void 0;
var z = __importStar(require("zod"));
/**
 * Portal email bodies edited with the rich editor are stored as TipTap/ProseMirror JSON.
 * This schema is the allowlist: the API only ever renders what parses here, so no raw HTML
 * is stored or sent. Unknown attributes are stripped; unknown node or mark types are rejected.
 */
exports.EmailBodyFormatSchema = z.enum(['plain', 'doc']);
exports.EMAIL_TEXT_ALIGNMENTS = ['left', 'center', 'right'];
exports.EMAIL_HEADING_LEVELS = [2, 3];
/** Atom node inserted by the editor for a `{{Token}}` placeholder, so formatting can never split it. */
exports.EMAIL_TOKEN_NODE = 'token';
exports.EMAIL_BODY_MAX_LENGTH = 200000;
var isSafeEmailHref = function (href) {
    return /^(https?:\/\/|mailto:)/i.test(href) && !/[\s<>"'`\u0000-\u001f]/.test(href);
};
exports.isSafeEmailHref = isSafeEmailHref;
var MarkSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('bold') }),
    z.object({ type: z.literal('italic') }),
    z.object({ type: z.literal('underline') }),
    z.object({
        type: z.literal('link'),
        attrs: z.object({
            href: z
                .string()
                .trim()
                .max(2000)
                .refine(exports.isSafeEmailHref, { message: 'Links must start with http://, https:// or mailto:' }),
        }),
    }),
]);
var MarksSchema = z.array(MarkSchema).max(4).optional();
var InlineSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('text'), text: z.string().min(1).max(20000), marks: MarksSchema }),
    z.object({ type: z.literal('hardBreak'), marks: MarksSchema }),
    z.object({
        type: z.literal(exports.EMAIL_TOKEN_NODE),
        attrs: z.object({ name: z.string().regex(/^\w+$/, { message: 'Invalid placeholder name' }) }),
        marks: MarksSchema,
    }),
]);
var TextAlignSchema = z.enum(exports.EMAIL_TEXT_ALIGNMENTS).nullable().optional();
var ParagraphSchema = z.object({
    type: z.literal('paragraph'),
    attrs: z.object({ textAlign: TextAlignSchema }).optional(),
    content: z.array(InlineSchema).optional(),
});
var HeadingSchema = z.object({
    type: z.literal('heading'),
    attrs: z.object({
        textAlign: TextAlignSchema,
        level: z.union([z.literal(exports.EMAIL_HEADING_LEVELS[0]), z.literal(exports.EMAIL_HEADING_LEVELS[1])]),
    }),
    content: z.array(InlineSchema).optional(),
});
var ListItemSchema = z.lazy(function () {
    return z.object({
        type: z.literal('listItem'),
        content: z.array(z.union([ParagraphSchema, BulletListSchema, OrderedListSchema])).min(1),
    });
});
var BulletListSchema = z.object({
    type: z.literal('bulletList'),
    content: z.array(ListItemSchema).min(1),
});
var OrderedListSchema = z.object({
    type: z.literal('orderedList'),
    attrs: z.object({ start: z.number().int().min(1).max(10000).optional() }).optional(),
    content: z.array(ListItemSchema).min(1),
});
exports.EmailDocumentSchema = z.object({
    type: z.literal('doc'),
    content: z.array(z.union([ParagraphSchema, HeadingSchema, BulletListSchema, OrderedListSchema])).max(1000),
});
var TOKEN_PATTERN = /\{\{(\w+)\}\}/g;
var tokenizeLine = function (line) {
    var _a;
    var nodes = [];
    var last = 0;
    for (var _i = 0, _b = Array.from(line.matchAll(TOKEN_PATTERN)); _i < _b.length; _i++) {
        var match = _b[_i];
        var index = (_a = match.index) !== null && _a !== void 0 ? _a : 0;
        if (index > last)
            nodes.push({ type: 'text', text: line.slice(last, index) });
        nodes.push({ type: exports.EMAIL_TOKEN_NODE, attrs: { name: match[1] } });
        last = index + match[0].length;
    }
    if (last < line.length)
        nodes.push({ type: 'text', text: line.slice(last) });
    return nodes;
};
var tokenizeLines = function (text) {
    return text
        .split('\n')
        .flatMap(function (line, i) { return (i === 0 ? tokenizeLine(line) : __spreadArray([{ type: 'hardBreak' }], tokenizeLine(line), true)); });
};
/**
 * Converts the legacy plain body (`# ` heading, blank-line paragraphs) into a document that renders
 * the same way. The legacy heading was always centred, so the converted heading keeps that.
 */
var plainTextToEmailDocument = function (plain) {
    var paragraphs = (plain || '').split(/\n\n+/).filter(function (p) { return p.trim().length > 0; });
    var content = paragraphs.map(function (paragraph) {
        if (paragraph.startsWith('# ')) {
            return {
                type: 'heading',
                attrs: { level: 2, textAlign: 'center' },
                content: tokenizeLines(paragraph.slice(2).trim()),
            };
        }
        return { type: 'paragraph', content: tokenizeLines(paragraph) };
    });
    return { type: 'doc', content: content.length ? content : [{ type: 'paragraph' }] };
};
exports.plainTextToEmailDocument = plainTextToEmailDocument;
var walk = function (node, visit) {
    var _a;
    visit(node);
    (_a = node.content) === null || _a === void 0 ? void 0 : _a.forEach(function (child) { return walk(child, visit); });
};
/** Token names used by placeholder nodes and by complete `{{Token}}` text typed into the body. */
var extractEmailDocumentTokens = function (doc) {
    var found = new Set();
    walk(doc, function (node) {
        var _a;
        if (node.type === exports.EMAIL_TOKEN_NODE && ((_a = node.attrs) === null || _a === void 0 ? void 0 : _a.name))
            found.add(node.attrs.name);
        if (node.type === 'text' && node.text) {
            for (var _i = 0, _b = Array.from(node.text.matchAll(TOKEN_PATTERN)); _i < _b.length; _i++) {
                var match = _b[_i];
                found.add(match[1]);
            }
        }
    });
    return Array.from(found);
};
exports.extractEmailDocumentTokens = extractEmailDocumentTokens;
/**
 * A typed placeholder split by formatting (e.g. `{{First` bold + `Name}}`) would be sent literally.
 * Any brace pair left after removing complete placeholders means one is broken.
 */
var hasBrokenEmailPlaceholder = function (doc) {
    var broken = false;
    walk(doc, function (node) {
        if (node.type === 'text' && node.text && /\{\{|\}\}/.test(node.text.replace(TOKEN_PATTERN, '')))
            broken = true;
    });
    return broken;
};
exports.hasBrokenEmailPlaceholder = hasBrokenEmailPlaceholder;
var isEmailDocumentEmpty = function (doc) {
    var hasContent = false;
    walk(doc, function (node) {
        var _a;
        if (node.type === exports.EMAIL_TOKEN_NODE || (node.type === 'text' && ((_a = node.text) === null || _a === void 0 ? void 0 : _a.trim())))
            hasContent = true;
    });
    return !hasContent;
};
exports.isEmailDocumentEmpty = isEmailDocumentEmpty;
var parseEmailDocument = function (body) {
    var json;
    try {
        json = JSON.parse(body);
    }
    catch (_a) {
        return { success: false, error: 'Body is not a valid document' };
    }
    var parsed = exports.EmailDocumentSchema.safeParse(json);
    if (!parsed.success) {
        var issue = parsed.error.errors[0];
        var detail = (issue === null || issue === void 0 ? void 0 : issue.code) === 'custom' || (issue === null || issue === void 0 ? void 0 : issue.code) === 'invalid_string'
            ? issue.message
            : 'only paragraphs, headings, lists, bold, italic, underline and links are supported';
        return { success: false, error: "Body contains unsupported content: ".concat(detail) };
    }
    return { success: true, data: parsed.data };
};
exports.parseEmailDocument = parseEmailDocument;
//# sourceMappingURL=EmailDocument.js.map